export default function getTextFromHTML(htmlString) {
  const d = document.createElement("div")
  d.innerHTML = htmlString

  return d.innerText
}
